import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { loadingItem } from "../../redux/actions";
import { itemSelector } from "../../redux/selectors";
import { Skeleton } from "@material-ui/lab";
import { ModuleAppBar } from "../ModuleAppBar";
import { ItemHeader } from "./ItemHeader";
import { ItemForm } from "./ItemForm";
import { EventNotificationActivityFeed } from "./activityFeed/EventNotificationActivityFeed";
import {
  LinkedRecords,
  LinkedRecordType,
} from "@ofqual/portal-linked-records/linked-records";
import { ScrollableAreaTabs } from "@ofqual/portal-components/components/ScrollableAreaTabs";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      [theme.breakpoints.up("lg")]: {
        marginTop: theme.contentOffsets.AFTER_RECORD_HEADER,
      },
      [theme.breakpoints.down("md")]: {
        marginTop: "25px",
      },
    },
  };
});

export const Item: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    dispatch(loadingItem(id));
  }, [dispatch, id]);

  const state = useSelector(itemSelector);

  const activityTab = {
    label: "Activity",
    content: <EventNotificationActivityFeed eventNotification={state.item} />,
  };

  const linkedRecordTab = {
    label: "Linked Records",
    content: (
      <LinkedRecords
        entityReferenceId={state.item?.id}
        entityTitle={state.item?.title}
        entityLinkedRecordType={LinkedRecordType.eventNotification}
      />
    ),
    tabTypeId: "linkedRecords",
  };

  return (
    <div className={classes.root}>
      <ModuleAppBar breadcrumbs={[{ label: "" }]} />
      <ItemHeader state={state} />

      <Grid container spacing={3}>
        <Grid item lg={6} xs={12}>
          {state.item ? (
            <ItemForm state={{ ...state, item: state.item }} />
          ) : (
            <>
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <Skeleton variant="text" height={60} />
              <br />
              <Skeleton variant="rect" height={118} />
            </>
          )}
        </Grid>

        <Grid item lg={6} xs={12}>
          <ScrollableAreaTabs
            twelfths={6}
            tabs={[activityTab, linkedRecordTab]}
          />
        </Grid>
      </Grid>
    </div>
  );
};
